<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="contact"
        :content="header"
      />
    </template>
    <template slot="main">
      <DetalleAdministrativeCentre v-if="SendType && !loading" ref="adminCentre" :form="form"/>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isRoleUserConsultaProvider"
            mode="primary"
            :text="$t('app.save')"
            icon="check"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import { i18n } from '@/i18n'

import DetailLayout from '@/components/layout/DetailLayout.vue'
import DetalleAdministrativeCentre from '@/components/DetalleAdministrativeCentre.vue'

import { getAdministrativeCenter } from '@/services/configurations/getAdministrativeCenter'
import { addAdministrativeCenter } from '@/services/configurations/addAdministrativeCenter'
import { updateAdministrativeCenter } from '@/services/configurations/updateAdministrativeCenter'


export default {
  /* eslint-disable camelcase */
  name: 'detail-administrative-center',
  components: {
    DetailLayout,
    DetalleAdministrativeCentre,
  },
  props: {
    SendType: {
      type: [String, Boolean],
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      searchView: false,
      activeName: 'es',
      distribuidores: [],
      header: {
        title: i18n.t('administrativecenter.header_long'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'masters/society/locations/administrativecenters'
      },
      loadedFirstTime: false,
      form: this.getDefaultForm(),
      clientes: [],
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return parseInt(this.$route.params.id)
    },
    idSede: function () {
      return parseInt(this.$route.params.idSede)
    },
    idCentro: function () {
      return parseInt(this.$route.params.idCentro)
    },
    isCreate: function () {
      return this.idCentro === -1
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserConsultaProvider: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
  },
  watch: {
    'form.AddressInSpain': function (value, oldValue) {
      if (value) {
        this.form.CountryCode = 'ESP'
      }
    },
  },
  created: async function () {
    if (this.SendType && !this.loading) {
      const breadcrumbs = []
  
      breadcrumbs.push({ path: 'masters', name: i18n.t('masters.header') })
      breadcrumbs.push({ path: 'masters/society', name: i18n.t('agenda.sociedad') })
      breadcrumbs.push({ path: 'masters/society/locations', name: i18n.t('sedes.header') })
      breadcrumbs.push({ path: 'masters/society/locations/administrativecenters', name: i18n.t('administrativecenter.header') })
      if (!this.isCreate) {
        await this.downloadData(this.idCentro)
        const cabecera = `${i18n.t('address.location')}: ${this.truncate(this.form.Address, 30, false)}`
        breadcrumbs.push({ path: '', name: cabecera })
        this.$store.commit('app/setheaderBreadCrumb', cabecera)
      } else {
        this.$route.params.idCentro = -1
        breadcrumbs.push({
          path: '',
          name: i18n.t('administrativecenter.new')
        })
      }
      this.header.breadcrumb = breadcrumbs
    }
  },
  methods: {
    getDefaultForm: function () {
      return {
        CentreCode: '',
        RoleCode: '',
        Name: '',
        FirstSurname: '',
        SecondSurname: '',
        Address: '',
        PostCode: '',
        Town: '',
        Province: '',
        CountryCode: 'ESP',
        Telephone: '',
        TeleFax: '',
        WebAddress: '',
        ElectronicMail: '',
        ContactPersons: '',
        CnoCnae: '',
        INETownCode: '',
        AdditionalDetails: '',
        PhysicalIGLN: '',
        LogicalOperationalPoint: '',
        CentreDescription: '',
      }
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function () {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs.adminCentre.validate(valid => {
        if (valid) {
          const params = {
            IdSociedad: this.id,
            IdSede: this.idSede,
            CentreCode: this.form.CentreCode || '',
            RoleCode: this.form.RoleCode || '',
            Name: this.form.Name || '',
            FirstSurname: this.form.FirstSurname || '',
            SecondSurname: this.form.SecondSurname || '',
            Address: {
              Address: this.form.Address || '',
              PostCode: this.form.PostCode || '',
              Town: this.form.Town || '',
              Province: this.form.Province || '',
              CountryCode: this.form.CountryCode || '',
            },
            ContactDetails: {
              Telephone: this.form.Telephone || '',
              TeleFax: this.form.TeleFax || '',
              WebAddress: this.form.WebAddress || '',
              ElectronicMail: this.form.ElectronicMail || '',
              ContactPersons: this.form.ContactPersons || '',
              CnoCnae: this.form.CnoCnae || '',
              INETownCode: this.form.INETownCode || '',
              AdditionalDetails: this.form.AdditionalDetails || '',
            },
            PhysicalIGLN: this.form.PhysicalIGLN || '',
            LogicalOperationalPoint: this.form.LogicalOperationalPoint || '',
            CentreDescription: this.form.CentreDescription || '',
          }
          
          if (this.isCreate) {
            this.newAdministrativeCenterHandler(params)
          } else {
            this.updateAdministrativeCenterHandler(params)
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
          this.$store.commit('setIsLoading', false)
        }
      })
    },
    resetForm: async function () {
      this.$refs.adminCentre.getDefaultForm()
    },
    newAdministrativeCenterHandler: async function (params) {
      const response = await addAdministrativeCenter(params)
      if (response.blnError === true) {
        this.doFeedback(`${response.msgError} [${response.codError}]`)
      } else {
        this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
        this.resetForm()
        this.form = this.getDefaultForm()
        this.goBack()
      }
     
      this.$store.commit('setIsLoading', false)
    },
    updateAdministrativeCenterHandler: async function (params) {
      const data = {
        ...params,
        IdAdministrativeCentre: this.idCentro
      }
      const response = await updateAdministrativeCenter(data)
      if (response.blnError === false) {
        this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
        this.goBack()
        this.updateView()
      } else {
        this.doFeedback(response.msgError)
      }

      this.$store.commit('setIsLoading', false)
    },
    goBack: function () {
      this.$router.push({ 
        name: 'masters/society/locations/administrativecenters',
        params: { id: this.id, idSede: parseInt(this.$route.params.idSede) }  
      })
    },
    downloadData: async function (idCentro) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idSociedad: this.id,
          idSede: this.idSede,
          idCentro: idCentro
        }
        const res = await getAdministrativeCenter(params)
        this.setContact(res.respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setContact: function (contact) {
      this.form.CentreCode = contact.CentreCode
      this.form.RoleCode = contact.RoleCode
      this.form.Name = contact.Name
      this.form.FirstSurname = contact.FirstSurname
      this.form.SecondSurname = contact.SecondSurname
      this.form.Address = contact.Address.Address
      this.form.PostCode = contact.Address.PostCode
      this.form.Town = contact.Address.Town
      this.form.Province = contact.Address.Province
      this.form.CountryCode = contact.Address.CountryCode
      this.form.Telephone = contact.ContactDetails.Telephone
      this.form.TeleFax = contact.ContactDetails.TeleFax
      this.form.WebAddress = contact.ContactDetails.WebAddress
      this.form.ElectronicMail = contact.ContactDetails.ElectronicMail
      this.form.ContactPersons = contact.ContactDetails.ContactPersons
      this.form.CnoCnae = contact.ContactDetails.CnoCnae
      this.form.INETownCode = contact.ContactDetails.INETownCode
      this.form.AdditionalDetails = contact.ContactDetails.AdditionalDetails
      this.form.PhysicalIGLN = contact.PhysicalIGLN
      this.form.LogicalOperationalPoint = contact.LogicalOperationalPoint
      this.form.CentreDescription = contact.CentreDescription
    },
    updateView: function () {
      const cabecera = `${i18n.t('address.location')}: ${this.truncate(this.form.Address, 30, false)}`
      this.header.breadcrumb[4].name = cabecera
      this.$store.commit('app/setheaderBreadCrumb', cabecera)
    },
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
